import BaseView from '../internals/BaseView';
import BaseForm from '../internals/BaseForm';
import BaseFooter from '../internals/BaseFooter';

const Body = BaseForm.extend({
  title () {
    const msg = this.options.appState.get('terminal').message || {};
    return msg.message || 'You can close this window';
  },
  noButtonBar: true,
  postRender () {
    BaseForm.prototype.postRender.apply(this, arguments);
    this.$el.addClass('terminal-state');
  },
});

const Footer = BaseFooter.extend({
  links () {
    return [
      {
        'type': 'link',
        'label': 'Back to sign in',
        'name': 'back',
        'href': '/'
      }
    ];
  }
});

export default BaseView.extend({
  Body,
  Footer
});



// WEBPACK FOOTER //
// ./src/v2/view-builder/views/TerminalView.js


// WEBPACK FOOTER //
// webpack:///src/v2/view-builder/views/TerminalView.js